import { render, staticRenderFns } from "./FinishView.vue?vue&type=template&id=c82fefde&scoped=true"
import script from "./FinishView.vue?vue&type=script&lang=js"
export * from "./FinishView.vue?vue&type=script&lang=js"
import style0 from "./FinishView.vue?vue&type=style&index=0&id=c82fefde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82fefde",
  null
  
)

export default component.exports